import { BaseDb } from "common/BaseDb"
import { AreasSchema } from "components/project/areas/areas.schema"

class AreasDb extends BaseDb<AreasSchema> {}

const areasDb = new AreasDb("project/areas")
export default areasDb
